"use client";
import { useEffect, useState } from "react";
import { useMediaQuery } from "@mui/material";
import { useRouter } from "next/navigation";
import { useCookies } from "react-cookie";
import CustomButton from "@/common/customElements/button";
import { InlineDiv } from "@/common/divs";
import { LightText, RegularText } from "@/common/texts";
import { PRIMARY_BUTTON_COLOR } from "@/utils/constants";

const CookieConsent = () => {
  const [cookies, setCookie] = useCookies(["cookieConsent"]);
  const [cookies2, setCookie2] = useCookies(["ga-consent"]);
  const [funcionalCookies, setFunctionalCookies] = useCookies([
    "functionalCookies",
  ]);

  const giveCookieConsent = () => {
    if (cookies) {
      setCookie("cookieConsent", true, { path: "/" });
      setCookie2("ga-consent", true, { path: "/" });
    }
  };

  const denyCookieConsent = () => {
    if (cookies) {
      setCookie("cookieConsent", false, { path: "/" });
      setFunctionalCookies("functionalCookies", true, { path: "/" });
    }
  };

  const [isCookieConsent, setIsCookieConsent] = useState(false);

  useEffect(() => {
    if (
      cookies.cookieConsent ||
      funcionalCookies.functionalCookies ||
      cookies2["ga-consent"]
    ) {
      setIsCookieConsent(true);
    }
  }, [cookies, cookies2, funcionalCookies]);

  const isMobile = useMediaQuery("(max-width:540px)");
  const router = useRouter();
  return (
    <div
      style={{
        position: "fixed",
        bottom: "0",
        right: "0",
        backgroundColor: "#fff0b5",
        padding: "20px",
        display: isCookieConsent ? "none" : "flex",
        justifyContent: "left",
        width: isMobile ? "100%" : "540px",
        border: "1px solid #eaeaea",
        flexDirection: "column",
        gap: "10px",
        borderRadius: "16px",
        zIndex: "999",
      }}
    >
      <LightText fontSize="12px">
        Utilizamos cookies para optimizar nuestro sitio web y nuestro servicio.
        No consentir o retirar el consentimiento, puede afectar negativamente a
        ciertas características y funciones.
      </LightText>
      <InlineDiv style={{ gap: "10px", flexWrap: "wrap" }}>
        <CustomButton
          width="250px"
          height="50px"
          backgroundColor={PRIMARY_BUTTON_COLOR}
          onClick={giveCookieConsent}
        >
          <RegularText fontSize="14px">Aceptar todas las cookies</RegularText>
        </CustomButton>
        <CustomButton
          width="250px"
          height="50px"
          backgroundColor={PRIMARY_BUTTON_COLOR}
          onClick={denyCookieConsent}
        >
          <RegularText fontSize="14px">Rechazar cookies opcionales</RegularText>
        </CustomButton>
      </InlineDiv>
      <LightText
        style={{ cursor: "pointer", textDecoration: "underline" }}
        onClick={() => {
          router.push("/terms-and-conditions");
        }}
        fontSize="12px"
      >
        Politica de cookies
      </LightText>
    </div>
  );
};

export default CookieConsent;
